module.exports = {"540225100":"曲下镇","540225101":"拉孜镇","540225200":"扎西宗乡","540225201":"曲玛乡","540225202":"彭措林乡","540225203":"扎西岗乡","540225204":"柳乡","540225205":"热萨乡","540225206":"锡钦乡","540225207":"芒普乡","540225208":"查务乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540225.json
// module id = 2828
// module chunks = 0